import { render, staticRenderFns } from "./MResetPassSet.vue?vue&type=template&id=8a9b8cc4&scoped=true&"
import script from "./MResetPassSet.vue?vue&type=script&lang=ts&"
export * from "./MResetPassSet.vue?vue&type=script&lang=ts&"
import style0 from "./MResetPassSet.vue?vue&type=style&index=0&id=8a9b8cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9b8cc4",
  null
  
)

export default component.exports